import Consts from '../../consts/adminConsts'
import QuestionVisiblePolicyModel from './QuestionVisiblePolicy'
import QuestionOptionModel from './QuestionOption'

export default class {

    Id = null;

    Name = null;

    TechnicalName = null;

    // Подсказка
    Prompt = null;

    IsRequired = null;

    IsPhotoRequired = false;

    PhotoCategoryId = null;

    // Место в аудите
    Place = null;

    // Ответ на вопрос по умолчанию
    DefaultValue = null;

    Type = null;

    // Тип ответа
    AnswerType = null;

    // Отображать если / Не отображать если
    VisibleCondition = null;

    // Варианты ответа (могут быть удалены/добавлены/отсортированы 
    // в случае, если AnswerOptions: 20 - 22 включительно)
    Options = [];

    // Политики видимости (удаляются, обновляются, сортируются)
    VisiblePolicies = [];

    // Привязанные блоки вопросов
    Blocks = [];

    // Привязанные подвопросы
    SubQuestions = [];

    // Политики видимости вопросов,
    // которые зависят от ответов на текущий вопрос
    ReferenceQuestions = [];

    // Политики видимости блоков вопросов,
    // которые зависят от ответов на текущий вопрос
    ReferenceBlocks = [];

    mapFromDto(questionDto) {
        if (!questionDto)
            return this;

        this.Id = questionDto.Id;
        this.Name = questionDto.Name;
        this.TechnicalName = questionDto.TechnicalName;
        this.Prompt = questionDto.Prompt;
        this.IsRequired = questionDto.IsRequired;
        this.IsPhotoRequired = questionDto.IsPhotoRequired;
        this.PhotoCategoryId = questionDto.PhotoCategoryId;
        this.Place = Consts.PlaceTypes.find(e => e.Id == questionDto.Place);
        this.DefaultValue = questionDto.DefaultValue;

        this.Type = Consts.QuestionTypes.find(e => e.Id == questionDto.Type);
        this.AnswerType = Consts.AnswerTypes.find(e => e.Id == questionDto.AnswerType);
        this.VisibleCondition = Consts.VisibleConditionTypes.find(e => e.Id == questionDto.VisibleCondition);

        this.Options = questionDto.Options.map(e => new QuestionOptionModel().mapFromDto(e));
        this.VisiblePolicies = questionDto.VisiblePolicies.map(e => new QuestionVisiblePolicyModel().mapFromDto(e));
        this.Blocks = questionDto.Blocks;
        this.SubQuestions = questionDto.SubQuestions;
        this.ReferenceQuestions = questionDto.ReferenceQuestions;
        this.ReferenceBlocks = questionDto.ReferenceBlocks;

        return this;
    }

    //Проверка на валидность структуры
	isValid = function () {
        var isName = isNotNull(this.Name) && this.Name !== "";
        var isTechnicalName = isNotNull(this.TechnicalName) && this.TechnicalName !== "";
		var isRequired = isNotNull(this.IsRequired);
		var isType = isNotNull(this.Type);
		var isPhotoRequired = isType && (this.Type.Id === 2 || (this.Type.Id === 1 && isNotNull(this.Type)));
		var isPlace = isType && (this.Type.Id === 2 || (this.Type.Id === 1 && isNotNull(this.Place)));
		var isVC = isNotNull(this.VisibleCondition);
		var isAnswerType = isNotNull(this.AnswerType);

		var isAllOptionsValid = this.Options.every(o => o.isValid());
		var isAllVisiblePoliciesValid = this.VisiblePolicies.every(o => o.isValid());

        return isName &&
            isTechnicalName &&
			isRequired &&
			isType &&
			isPhotoRequired &&
			isPlace &&
			isVC &&
			isAnswerType &&
			isAllOptionsValid &&
			isAllVisiblePoliciesValid;
    }
    
    //Мап в серверную модель из страничной
	mapToDto = function () {    
        var result = JSON.parse(JSON.stringify(this));

        if(result.VisiblePolicies.length)
            result.VisiblePolicies = this.VisiblePolicies.map(e => e.mapToDto());
        
		result.Place = isNotNull(result.Place) ? result.Place.Id : 0;
		result.VisibleCondition = result.VisibleCondition.Id;
		result.Type = result.Type.Id;
        result.AnswerType = result.AnswerType.Id;

        if (result.Blocks.length)
            result.Blocks = result.Blocks.map(e => e.Id);

        if (result.PhotoCategoryId)
            result.PhotoCategoryId = result.PhotoCategoryId.Id;

        if(result.AnswerType == 21 || result.AnswerType == 40 || result.AnswerType > 100)
            result.DefaultValue = result.DefaultValue == null ? null : String(result.DefaultValue);
          else if(result.AnswerType != 30)
            result.DefaultValue = result.DefaultValue == null || result.DefaultValue === false ? null : String(result.DefaultValue);

        return result;
    }

    addOption() {
        this.Options.push(new QuestionOptionModel());
    }

    removeOption = function (index) {
        this.Options.splice(index, 1);
    }
}

function isNotNull(object) {
    return typeof (object) !== "undefined" && object !== null;
}